import { useEffect, useState } from 'react'
import { Sidebar } from './Sidebar.js'

function useDesktopSidebar(): boolean {
  const [isDesktop, setIsDesktop] = useState(() => typeof window === 'undefined' || window.innerWidth >= 700)

  useEffect(() => {
    const update = () => setIsDesktop(typeof window === 'undefined' || window.innerWidth >= 700)
    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [])

  return isDesktop
}

export function AppShell({ children }: { children: React.ReactNode }) {
  const showSidebar = useDesktopSidebar()
  return (
    <div className="app-shell">
      {showSidebar ? <Sidebar /> : null}
      <div className="app-main">{children}</div>
    </div>
  )
}
